import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShieldCheck, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Brand } from "@/components/common/Brand";
import { LanguageSwitcher } from "@/components/common/LanguageSwitcher";
export function Header() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const links = [
    {
      to: "/",
      label: t("nav.home"),
    },
    {
      to: "/jobs",
      label: t("nav.jobs"),
    },
    // {
    //   to: "/kyc",
    //   label: t("nav.kyc"),
    // },
  ];
  const navClass = ({ isActive }) =>
    `rounded-lg px-3 py-2 text-sm font-semibold transition ${isActive ? "bg-navy-50 text-navy-800" : "text-slate-600 hover:bg-slate-50 hover:text-navy-900"}`;
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/95 backdrop-blur-xl">
      <div className="container-shell flex h-18 items-center justify-between py-3">
        <Brand />
        <nav
          className="hidden items-center gap-1 lg:flex"
          aria-label={t("nav.primary")}
        >
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} className={navClass}>
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          {/* <LanguageSwitcher /> */}
          {/* <Link to="/kyc" className="btn-primary min-h-10 px-4 py-2">
            <ShieldCheck className="size-4" />
            {t("nav.startApplication")}
          </Link> */}
        </div>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="flex size-11 items-center justify-center rounded-xl border border-slate-200 text-navy-900 lg:hidden"
          aria-expanded={open}
          aria-label={open ? t("nav.close") : t("nav.menu")}
        >
          {open ? <X className="size-5" /> : <Menu className="size-5" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-100 bg-white px-4 pb-5 pt-3 lg:hidden">
          <nav
            className="mx-auto flex max-w-7xl flex-col gap-1"
            aria-label={t("nav.mobile")}
          >
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={navClass}
              >
                {link.label}
              </NavLink>
            ))}
            <div className="my-2 border-t border-slate-100" />
            {/* <LanguageSwitcher /> */}
            {/* <Link
              to="/kyc"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2"
            >
              <ShieldCheck className="size-4" />
              {t("nav.startApplication")}
            </Link> */}
          </nav>
        </div>
      )}
    </header>
  );
}
